import { QueryKey } from '@/configs/queryKeys';
import { Attachment, Translations } from '@/types/types';
import EntityApi, { EntityBase } from './EntityApi';

export enum ContentType {
	TEXT,
	IMAGE,
	ELEMENT,
}

export interface Content extends EntityBase {
	slug: string;
	type: ContentType;
	content: string;
	image: Pick<Attachment, 'id' | 'path'>;
	translations: Translations<{
		content: string;
		image: Pick<Attachment, 'id' | 'path'>;
	}>;
}
class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}
}

export default new ContentApi();
